import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from "@angular/material/select";
import { TranslateModule } from "@ngx-translate/core";
import { LocalizedStringPipeModule } from "app/shared/localized-string-pipe/localized-string-pipe.module";
import { DynamicDateComponent } from './dynamic-date/dynamic-date.component';
import { DynamicInputComponent } from "./dynamic-input/dynamic-input.component";
import { DynamicNumberComponent } from './dynamic-number/dynamic-number.component';
import { DynamicRadioGroupComponent } from './dynamic-radio-group/dynamic-radio-group.component';
import { DynamicSelectComponent } from "./dynamic-select/dynamic-select.component";
import { DynamicTextComponent } from './dynamic-text/dynamic-text.component';
import { DynamicYesNoComponent } from './dynamic-yes-no/dynamic-yes-no.component';

@NgModule({
  declarations: [
    DynamicInputComponent,
    DynamicTextComponent,
    DynamicDateComponent,
    DynamicNumberComponent,
    DynamicYesNoComponent,
    DynamicRadioGroupComponent,
    DynamicSelectComponent
  ],
  exports: [
    DynamicInputComponent,
    DynamicTextComponent,
    DynamicDateComponent,
    DynamicNumberComponent,
    DynamicYesNoComponent,
    LocalizedStringPipeModule,
    DynamicRadioGroupComponent,
    DynamicSelectComponent
  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatDatepickerModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    LocalizedStringPipeModule,
    MatSelectModule
  ],
})
export class UtilsModule {

}